import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sf-dr-wrapper',
  template: `
    <div>
      wrapper
      <ng-content></ng-content>
    </div>
  `,
})
export class WebDrSfWrapperComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
